<script setup>
/* eslint-disable */
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { applyThemeClasses } from '@/utils/themeColors'

// Add this to explicitly define the component
defineOptions({
  name: 'TransitOverlay'
})

const dots = ref('')
const message = ref('Currently in Transit')
const tick = ref(0)

let interval

onMounted(() => {
  interval = setInterval(() => {
    dots.value = dots.value.length >= 3 ? '' : dots.value + '.'
    tick.value++
    
    if (tick.value < 3) {
      message.value = 'Changing a wheel on the wagon'
    } else if (tick.value < 6) {
      message.value = 'Overnight at an inn'
    } else if (tick.value < 9) {
      message.value = 'On your way back now!'
    } else {
      message.value = 'Parking up'
    }
  }, 400)
})

onBeforeUnmount(() => {
  clearInterval(interval)
})
</script>

<template>
  <div :class="`fixed inset-0 ${applyThemeClasses('components.modal.overlay')} flex items-center justify-center z-[60] overflow-y-auto`">
    <div :class="`rounded-lg ${applyThemeClasses('components.modal.container')} w-full min-w-[350px] max-w-4xl mx-auto my-2 p-6`">
      <div class="flex items-center justify-center mb-4">
        <div class="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
      <p class="text-center" :class="applyThemeClasses('text.primaryLow')">
        {{ message }}{{ dots }}
      </p>
    </div>
  </div>
</template>